const CompanyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 5.75C3 3.67893 4.67893 2 6.75 2H12.25C14.3211 2 16 3.67893 16 5.75V22H3V5.75ZM6.75 3.5C5.50736 3.5 4.5 4.50736 4.5 5.75V20.5H14.5V5.75C14.5 4.50736 13.4926 3.5 12.25 3.5H6.75Z"
        fill="#393D63"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5 7.75C14.5 7.33579 14.8358 7 15.25 7H17.25C19.3211 7 21 8.67893 21 10.75V21.25C21 21.6642 20.6642 22 20.25 22C19.8358 22 19.5 21.6642 19.5 21.25V10.75C19.5 9.50736 18.4926 8.5 17.25 8.5H15.25C14.8358 8.5 14.5 8.16421 14.5 7.75Z"
        fill="#393D63"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 21.25C2 20.8358 2.33579 20.5 2.75 20.5H21.25C21.6642 20.5 22 20.8358 22 21.25C22 21.6642 21.6642 22 21.25 22H2.75C2.33579 22 2 21.6642 2 21.25Z"
        fill="#393D63"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25 16.25C6.25 15.2835 7.0335 14.5 8 14.5H11C11.9665 14.5 12.75 15.2835 12.75 16.25V21.25C12.75 21.6642 12.4142 22 12 22C11.5858 22 11.25 21.6642 11.25 21.25V16.25C11.25 16.1119 11.1381 16 11 16H8C7.86193 16 7.75 16.1119 7.75 16.25V21.25C7.75 21.6642 7.41421 22 7 22C6.58579 22 6.25 21.6642 6.25 21.25V16.25Z"
        fill="#393D63"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25 11.75C6.25 11.3358 6.58579 11 7 11H8C8.41421 11 8.75 11.3358 8.75 11.75C8.75 12.1642 8.41421 12.5 8 12.5H7C6.58579 12.5 6.25 12.1642 6.25 11.75Z"
        fill="#393D63"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.25 11.75C10.25 11.3358 10.5858 11 11 11H12C12.4142 11 12.75 11.3358 12.75 11.75C12.75 12.1642 12.4142 12.5 12 12.5H11C10.5858 12.5 10.25 12.1642 10.25 11.75Z"
        fill="#393D63"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25 8.75C6.25 8.33579 6.58579 8 7 8H8C8.41421 8 8.75 8.33579 8.75 8.75C8.75 9.16421 8.41421 9.5 8 9.5H7C6.58579 9.5 6.25 9.16421 6.25 8.75Z"
        fill="#393D63"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.25 8.75C10.25 8.33579 10.5858 8 11 8H12C12.4142 8 12.75 8.33579 12.75 8.75C12.75 9.16421 12.4142 9.5 12 9.5H11C10.5858 9.5 10.25 9.16421 10.25 8.75Z"
        fill="#393D63"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25 5.75C6.25 5.33579 6.58579 5 7 5H8C8.41421 5 8.75 5.33579 8.75 5.75C8.75 6.16421 8.41421 6.5 8 6.5H7C6.58579 6.5 6.25 6.16421 6.25 5.75Z"
        fill="#393D63"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.25 5.75C10.25 5.33579 10.5858 5 11 5H12C12.4142 5 12.75 5.33579 12.75 5.75C12.75 6.16421 12.4142 6.5 12 6.5H11C10.5858 6.5 10.25 6.16421 10.25 5.75Z"
        fill="#393D63"
      />
    </svg>
  )
}
export default CompanyIcon
